import { ENGINE_MATCHER_STARTS_WITH } from '../../logger/constants';
import { startsWith } from '../../utils/lang';
export function startsWithMatcherContext(log, ruleAttr) {
    return function startsWithMatcher(runtimeAttr) {
        var matches = ruleAttr.some(function (e) { return startsWith(runtimeAttr, e); });
        log.debug(ENGINE_MATCHER_STARTS_WITH, [runtimeAttr, ruleAttr, matches]);
        return matches;
    };
}
